import React from "react";
import i18n from '../../i18n';

export const Success: React.FC = () => {
  return (
    <div className="row">
      <div className="col-12 text-center">
        <img src='/suitcase.svg' className="finished-header" alt="suitcase logo" />
      </div>
      <div className="col-12 text-center">
        <h1 className="finished-header">{i18n.t('YourAccountDeleted')}</h1>
        <span style={{color: '#666'}}>{i18n.t('WeAreSadSeeYouGo')}</span>
      </div>
    </div>
  );
}